import React, { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../common/atoms';
import { Tabbar } from '../common/molecules';
import { RatingsManager, ContractsManager, WalletUtilizationManager } from '../../managers';
import { utilizationApi } from '../../services';
import { handleAppError } from '../handlers';
import { PharmacyLocked, PharmacyLow } from '../../assets/images';
import { UtilizationLockScreen, NoUtilizationCard } from '../common/organisms';
import { PHARMACY_LOCKED_CONTENT } from '../../constants/utilization';
import {Pharmacy} from '../common/templates/Utilization';
import moment from 'moment';
import DateRangePicker from '../tailwind/molecules/DateRangePicker';
import MetricManager from '../../managers/PharmacyManager';
import { SALES_ROLE } from '../../constants/overview';
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';
let token = '';

class PharmacyPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metricObj: {},
      ratingObj: {},
      coverageObj: {},
      walletUtilizationObj: {},
      spentSavingsObj: {},
      benefitName: 'Pharmacy',
      loading: true,
      showNoUtilization: false,
      
      filterDates: {startDate: null, endDate: null}
    };
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    this.setState({loading: true })
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date =  moment(start_date).format('YYYY-MM-DD')
    end_date =  moment(end_date).format('YYYY-MM-DD')

    var promise1 = utilizationApi.pharmacyFetchMetrics({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise2 = utilizationApi.pharmacyFetchRatings({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise3 = utilizationApi.pharmacyFetchSpendings({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise4 = utilizationApi.pharmacyFetchCoverage({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    
    Promise.all([promise1, promise2, promise3, promise4])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = new MetricManager(resp_arr[0]);
        var ratingObj = new RatingsManager(resp_arr[1]);
        var spentSavingsObj = resp_arr[2];
        var coverageObj = resp_arr[3];
        var showNoUtilization = metricObj.totalAmountSpent < 1;
        this.setState({ metricObj, ratingObj, coverageObj, spentSavingsObj, loading: false, showNoUtilization});
      })
      .catch((err) => handleAppError(err));
  };

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'PHARMACY');
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          startDate: contractObj.formattedData[0].start_date,
          endDate: contractObj.formattedData[0].end_date,
          totalCustomers: contractObj.formattedData[0].total_customers,
          filterDates: { startDate: contractObj.formattedData[0]?.start_date, endDate: contractObj.formattedData[0]?.end_date }
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ((this.state.contractId && prevState.contractId !== this.state.contractId)|| (this.state.filterDates.startDate && prevState.filterDates.startDate !== this.state.filterDates.startDate) || (this.state.filterDates.endDate && prevState.filterDates.endDate !== this.state.filterDates.endDate)) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.filterDates.startDate, this.state.filterDates.endDate);
    }
  }

  toggleHelp = () => this.props.toggleHelp('Pharmacy');

  content = (selectedContractObj) => {
    const { loading, showNoUtilization } = this.state;

    if (loading || selectedContractObj.enable_pharmacy) {
      return showNoUtilization ? (
        <NoUtilizationCard
          line='utilization of pharmacy including prescription and OTC medication'
          imgsrc={PharmacyLow}
          toggleHelp={this.toggleHelp}
          classes='mt-8'
        />
      ) : (
        <Pharmacy {...this.state} />
      );
    } else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle='Pharmacy is not enabled'
            image={PharmacyLocked}
            sectionSubtitle='Benefits to your employees'
            points={PHARMACY_LOCKED_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };

  changeContractId = (contract) => {
    const { contractId } = this.state;
    const { contract_id, start_date, end_date } = contract;
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        selectedContractObj: contract,
        metricObj: {},
        ratingObj: {},
        walletUtilizationObj: {},
        coverageObj: {},
        loading: true,
        showNoUtilization: false,
        filterDates: {startDate: contract?.start_date, endDate: contract?.end_date}
      });
    }
  };

  changeDates = (e, date_type) =>{
    let date = moment(e).format('YYYY-MM-DD')
    if (e){
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: date}})
      }
      else if(date_type === 'endDate') {
        this.setState({filterDates: {...this.state.filterDates, endDate: date}})
      }
      else if(date_type === 'reset'){
        this.setState({filterDates: {startDate: moment(this.state.selectedContractObj?.start_date)}, endDate: moment(this.state.selectedContractObj?.end_date)})
      }
    }
    else{
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: moment(this.state.selectedContractObj.start_date).format('YYYY-MM-DD')}})
      }
      else {
        this.setState({filterDates: {...this.state.filterDates, endDate: moment(this.state.selectedContractObj.end_date).format('YYYY-MM-DD')}})
      }
    }
  };

  navigateToActivityLog = () => {
    const { start_date, end_date, contract_id } = this.state.selectedContractObj
    this.props.history.push(`/activity-log?point=pharmacy`, { start_date, end_date, contract_id });
  };

  render() {
    const { contractObj, loading } = this.state;
    const formattedData = contractObj ? contractObj.formattedData : null;

    return (
      <div className='min-w-0'>
        <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
          <div className='min-w-0'>
            <Breadcrumb
              list={[
                { text: 'Utilization', link: '/utilization/ahc' },
                { text: 'Pharmacy', link: '/pharmacy' },
              ]}
              classes='mb-1'
            />
            {typeof this.state.selectedContractObj !== 'undefined' && (
              <Heading
                mainHeading='Utilization of Pharmacy'
                mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl'
              />
            )}
          </div>
          <div className='flex shrink-0 flex-wrap gap-2 lg:justify-end'>
            <button
              type='button'
              onClick={this.navigateToActivityLog}
              disabled={SALES_ROLE === 'sales' }
              className={joinButtonClasses(dsButtonPrimary, 'h-10 px-5', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
            >
              Activity Log
            </button>
          </div>
        </div>
        <div className='mt-6 flex justify-start'>
          <div className='text-xs font-semibold uppercase tracking-wider text-gray-500'>Contract period / year</div>
        </div>
        <div className='mt-3'>
          <Tabbar
            list={formattedData}
            loading={loading}
            currentPage={formattedData ? formattedData[0].text : null}
            setContract={this.changeContractId}
          />
        </div>
        {contractObj && (
          <div className='mt-3'>
            <DateRangePicker
              filterDates={this.state.filterDates}
              contractDates={[this.state.selectedContractObj?.start_date, this.state.selectedContractObj?.end_date]}
              changeDates={this.changeDates}
            />
          </div>
        )}
        {this.content(this.state.selectedContractObj)}
      </div>
    );
  }
}

export default PharmacyPage;
